import React from 'react'
import styled from '@emotion/styled'
import { ExternalButtonLink } from 'stylist'

const StyledExtBtnLink = styled(ExternalButtonLink)`
  margin-left: 1rem;
  color: white !important;
`
const BookFVButton = () => (
  <StyledExtBtnLink
    kind="primary"
    href="https://book.focusvision.com"
  >
    Book Project
  </StyledExtBtnLink>
)

export default BookFVButton



// WEBPACK FOOTER //
// ./src/routes/components/BookFVButton.js